import { Fragment } from 'react';
import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { PaperStyled, TableRowStyled } from '../styles';
import {
  TableCellGroupForInstallment,
  TableCellStyledForInstallment,
  TableFooterBoxStyled,
} from './styles';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { PaidInstallmentsMobileTable } from 'v3/shared/components/MobileTable/PaidInstallmentsMobileTable/index';
import { InstallmentStatusEnum } from 'v3/data/store/installments/enum';
import { IInstallment } from 'v3/data/store/installments/types';
import { useStoreSelector } from 'v3/data/store';
import { formatDateSimple } from 'utils/formatDate';
import { amountFormatter } from 'utils/formatters';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';

export const InstallmentTable = () => {
  const { isMobile } = useBreakpoints();
  const { item } = useStoreSelector((store) => store.installments);

  const paidItems: IInstallment[] = item.installments.filter(
    (item) => item.paymentStatus === InstallmentStatusEnum.PAID
  );

  if (paidItems.length === 0) { 
    return <NoItemsFound />;
  }

  return (
    <Fragment>
      {isMobile ? (
        <PaidInstallmentsMobileTable data={paidItems} count={item.installments.length} />
      ) : (
        <PaperStyled>
          <TableContainer sx={{ maxHeight: 450 }}>
            <TableMui>
              <TableHead>
                <TableRow>
                  <TableCellStyledForInstallment>Parcela</TableCellStyledForInstallment>
                  <TableCellStyledForInstallment>Data de vencimento</TableCellStyledForInstallment>
                  <TableCellStyledForInstallment>Data de pagamento</TableCellStyledForInstallment>
                  <TableCellStyledForInstallment>Valor da parcela</TableCellStyledForInstallment>
                </TableRow>
              </TableHead>

              <TableBody>
                {paidItems.map((row) => (
                  <TableRowStyled key={row.number}>
                    <TableCellGroupForInstallment>
                      <SubtitleMedium>{`${String(row.number).padStart(2, '0')} de ${String(item.installments.length).padStart(2, '0')}`}</SubtitleMedium>
                    </TableCellGroupForInstallment>
                    <TableCellGroupForInstallment>
                      <SubtitleMedium>{formatDateSimple(row.dueDate)}</SubtitleMedium>
                    </TableCellGroupForInstallment>
                    <TableCellGroupForInstallment>
                      <SubtitleMedium>{row.paymentDate ? formatDateSimple(row.paymentDate) : '-'}</SubtitleMedium>
                    </TableCellGroupForInstallment>
                    <TableCellGroupForInstallment>
                      <SubtitleMedium>{amountFormatter(row.amount)}</SubtitleMedium>
                    </TableCellGroupForInstallment>
                  </TableRowStyled>
                ))}
              </TableBody>
            </TableMui>
          </TableContainer>
          <TableFooterBoxStyled />
        </PaperStyled>
      )}
    </Fragment>
  );
};